(function () {
  'use strict';

  function initCarSolo(carousel) {
    const track = carousel.querySelector('[data-carsolo-track]');
    const dotsWrap = carousel.querySelector('[data-carsolo-dots]');
    if (!track || !dotsWrap) return;

    const originalSlides = Array.from(track.querySelectorAll('[data-carsolo-slide]'));
    if (!originalSlides.length) return;

    const desktopPerView = parseInt(carousel.getAttribute('data-desktop-per-view') || '3', 10);
    const mobilePerView = parseInt(carousel.getAttribute('data-mobile-per-view') || '2', 10);
    const autoplay = carousel.getAttribute('data-autoplay') === 'true';
    const autoplaySpeed = parseInt(carousel.getAttribute('data-autoplay-speed') || '5000', 10);

    let currentIndex = 0;
    let currentPage = 0;
    let totalPages = 0;
    let perView = getPerView();
    let autoplayTimer = null;
    let isAnimating = false;

    function getPerView() {
      return window.innerWidth <= 990 ? mobilePerView : desktopPerView;
    }

    function clearTrack() {
      while (track.firstChild) track.removeChild(track.firstChild);
    }

    function buildTrack() {
      clearTrack();

      perView = getPerView();

      const headClones = originalSlides.slice(-perView).map(slide => slide.cloneNode(true));
      const tailClones = originalSlides.slice(0, perView).map(slide => slide.cloneNode(true));

      headClones.forEach(slide => track.appendChild(slide));
      originalSlides.forEach(slide => track.appendChild(slide.cloneNode(true)));
      tailClones.forEach(slide => track.appendChild(slide));

      currentIndex = perView;
      updateSlideWidths();
      jumpToIndex(currentIndex, false);

      totalPages = Math.ceil(originalSlides.length / perView);
      buildDots();
      updateDots();
    }

    function updateSlideWidths() {
      const slides = Array.from(track.children);
      const width = 100 / perView;

      slides.forEach(slide => {
        slide.style.flex = '0 0 ' + width + '%';
        slide.style.minWidth = width + '%';
      });
    }

    function getTranslateX(index) {
      return -(100 / perView) * index;
    }

    function jumpToIndex(index, animate) {
      if (animate) {
        track.style.transition = 'transform 0.45s ease';
      } else {
        track.style.transition = 'none';
      }

      track.style.transform = 'translate3d(' + getTranslateX(index) + '%, 0, 0)';
    }

    function buildDots() {
      dotsWrap.innerHTML = '';

      for (let i = 0; i < totalPages; i++) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.setAttribute('aria-label', 'Ir al grupo ' + (i + 1));
        btn.addEventListener('click', function () {
          goToPage(i);
          restartAutoplay();
        });
        dotsWrap.appendChild(btn);
      }
    }

    function updateDots() {
      const dots = Array.from(dotsWrap.children);
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === currentPage);
      });
    }

    function normalizeIndex() {
      const realLength = originalSlides.length;

      if (currentIndex >= realLength + perView) {
        currentIndex = perView;
        jumpToIndex(currentIndex, false);
      }

      if (currentIndex < perView) {
        currentIndex = realLength + perView - perView;
        jumpToIndex(currentIndex, false);
      }
    }

    function updateCurrentPage() {
      const realIndex = ((currentIndex - perView) % originalSlides.length + originalSlides.length) % originalSlides.length;
      currentPage = Math.floor(realIndex / perView);
      if (currentPage >= totalPages) currentPage = 0;
      updateDots();
    }

    function next() {
      if (isAnimating) return;
      isAnimating = true;

      currentIndex += perView;
      jumpToIndex(currentIndex, true);

      window.setTimeout(function () {
        normalizeIndex();
        updateCurrentPage();
        isAnimating = false;
      }, 470);
    }

    function prev() {
      if (isAnimating) return;
      isAnimating = true;

      currentIndex -= perView;
      jumpToIndex(currentIndex, true);

      window.setTimeout(function () {
        normalizeIndex();
        updateCurrentPage();
        isAnimating = false;
      }, 470);
    }

    function goToPage(page) {
      if (isAnimating) return;

      currentPage = page;
      currentIndex = perView + (page * perView);
      jumpToIndex(currentIndex, true);
      updateDots();

      window.setTimeout(function () {
        normalizeIndex();
      }, 470);
    }

    function startAutoplay() {
      if (!autoplay) return;
      stopAutoplay();
      autoplayTimer = window.setInterval(function () {
        next();
      }, autoplaySpeed);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function restartAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    let resizeTimer = null;
    function onResize() {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        const newPerView = getPerView();
        if (newPerView !== perView) {
          buildTrack();
          restartAutoplay();
        } else {
          updateSlideWidths();
          jumpToIndex(currentIndex, false);
        }
      }, 120);
    }

    carousel.addEventListener('mouseenter', stopAutoplay);
    carousel.addEventListener('mouseleave', startAutoplay);
    carousel.addEventListener('focusin', stopAutoplay);
    carousel.addEventListener('focusout', startAutoplay);

    buildTrack();
    updateCurrentPage();
    startAutoplay();

    window.addEventListener('resize', onResize);

    carousel._qnCarSoloDestroy = function () {
      stopAutoplay();
      window.removeEventListener('resize', onResize);
    };
  }

  function initAllCarSolo() {
    const carousels = document.querySelectorAll('[data-carsolo-carousel]');
    carousels.forEach(function (carousel) {
      if (!carousel.dataset.carsoloReady) {
        carousel.dataset.carsoloReady = 'true';
        initCarSolo(carousel);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCarSolo);
  } else {
    initAllCarSolo();
  }

  document.addEventListener('shopify:section:load', initAllCarSolo);
})();